export type NotificationSettingsType = {
  id: number
  displayName: string
  isEnable: boolean
}

export type NotificationSettings = {
  notificationTypeId: number
  isEnable: boolean
}

export type NotificationSettingsRequest = {
  settings: NotificationSettings[]
}

export type NotificationSettingsResponse = {
  data: NotificationSettingsType[]
}

export const enum NotificationFilterTypes {
  StudentExam = 1,
  StudentHomework,
  StudentGroup,
}

export enum ExcludedNotificationTypes {
  NewHomeworks = 'Yangi uy vazifalar',
  HomeworkCheck = 'Uy vazifa tekshirilganda',
  HomeworkDeadline = 'Uy vazifa muddati yaqin qolsa',
}
